import { dayMonth, dayMonthTime, time } from './RuDates';

/**
 * Срок задачи одной строкой — порт `TaskTimingText` Android-версии.
 *
 * Задачу показывают два экрана: список задач и поиск, а feature-модули не зависят
 * друг от друга. Два отдельных форматтера со временем разошлись бы, и один и тот же
 * срок читался бы по-разному.
 */

/** Чем подсвечен срок задачи. */
export type TaskTiming = 'overdue' | 'today' | 'later' | 'done';

export function timingOf(moment: number, isCompleted: boolean, now: number): TaskTiming {
  if (isCompleted) return 'done';
  if (moment < now) return 'overdue';

  return sameDay(moment, now) ? 'today' : 'later';
}

export function timingText(moment: number, timing: TaskTiming): string {
  const at = new Date(moment);

  switch (timing) {
    case 'overdue':
      // Дата, а не «два дня назад»: юрист считает сроки по календарю, а не по ощущению.
      return `Просрочено — до ${dayMonth(at)}`;
    case 'today':
      return `Сегодня, ${time(at)}`;
    case 'later':
      return dayMonthTime(at);
    case 'done':
      return 'Выполнено';
  }
}

/** Один ли это день. Сравнение по местному календарю, а не по суткам в миллисекундах. */
export function sameDay(left: number, right: number): boolean {
  const a = new Date(left);
  const b = new Date(right);

  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/** Начало суток, в которые попадает момент, — точка отсчёта для группировки задач. */
export function startOfDay(moment: number): number {
  const at = new Date(moment);
  at.setHours(0, 0, 0, 0);

  return at.getTime();
}

const DAY_MS = 24 * 60 * 60 * 1000;

/** Сколько целых суток между днями двух моментов: 0 — сегодня, 1 — завтра. */
export function daysBetween(from: number, to: number): number {
  return Math.round((startOfDay(to) - startOfDay(from)) / DAY_MS);
}
